"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var Group = function Group(props) {
  // eslint-disable-next-line react/prop-types
  var selectProps = props.selectProps;
  return _react["default"].createElement("div", null, _react["default"].createElement(_reactSelect.components.Group, props), _react["default"].createElement(_Divider["default"], {
    variant: "middle",
    className: selectProps.classes.divider
  }));
};

var _default = Group;
exports["default"] = _default;